import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=3bfdf7ae&scoped=true&"
var script = {}
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=3bfdf7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdf7ae",
  null
  
)

export default component.exports